<div class="relative bg-gray-300 font-sans"><Main></Main></div>